import { useCallback } from 'react';
import {
  getDailyMissionsErrorMessage,
  isDailyMissionsApiSuccess,
} from '../../services/dailyMissionsApi';

export function useDailyMissionsSession(setError) {
  const handleApiResponse = useCallback(
    (res, fallback) => {
      if (!isDailyMissionsApiSuccess(res)) {
        setError(getDailyMissionsErrorMessage(res, fallback));
        return true;
      }
      return false;
    },
    [setError]
  );

  return { handleApiResponse };
}
